import { ArrowRightLeft, X } from 'lucide-react';
import { useState } from 'react';
import { BulkCloseModal } from './BulkCloseModal';
import { BulkTransferModal } from './BulkTransferModal';

interface Props {
  ticketIds: number[];
  /** Algum dos selecionados é de canal que exige motivo pra encerrar? */
  exigeMotivo?: boolean;
  onClear: () => void;
  /** Ids encerrados/transferidos com sucesso — saíram do controle do atendente. */
  onTicketsLeft?: (ticketIds: number[]) => void;
}

/**
 * Barra fixa na parte inferior da inbox quando há tickets selecionados.
 * Mostra contagem + botões "Encerrar" / "Transferir". Ações abrem modais
 * centralizados (BulkCloseModal / BulkTransferModal) com confirmação explícita.
 */
export function BulkActionBar({ ticketIds, exigeMotivo = true, onClear, onTicketsLeft }: Props) {
  const [closeOpen, setCloseOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col gap-1.5 border-n-200 border-t bg-n-0 p-3 shadow-md">
        <div className="flex items-center justify-between">
          <span className="font-bold text-[13px] text-n-800">
            {ticketIds.length} {ticketIds.length === 1 ? 'selecionado' : 'selecionados'}
          </span>
          <button
            type="button"
            onClick={onClear}
            className="flex h-7 w-7 items-center justify-center rounded-md text-n-500 hover:bg-n-100"
            aria-label="Cancelar seleção"
          >
            <X size={14} />
          </button>
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setCloseOpen(true)}
            className="flex-1 rounded-md bg-danger-500 px-3 py-2 font-bold text-[11px] text-white uppercase hover:bg-danger-600"
          >
            Encerrar
          </button>
          <button
            type="button"
            onClick={() => setTransferOpen(true)}
            className="flex flex-1 items-center justify-center gap-1 rounded-md bg-brand-500 px-3 py-2 font-bold text-[11px] text-white uppercase hover:bg-brand-600"
          >
            <ArrowRightLeft size={12} />
            Transferir
          </button>
        </div>
      </div>

      <BulkCloseModal
        open={closeOpen}
        ticketIds={ticketIds}
        exigeMotivo={exigeMotivo}
        onClose={() => setCloseOpen(false)}
        onSuccessAll={onClear}
        {...(onTicketsLeft && { onSucceeded: onTicketsLeft })}
      />
      <BulkTransferModal
        open={transferOpen}
        ticketIds={ticketIds}
        onClose={() => setTransferOpen(false)}
        onSuccessAll={onClear}
        {...(onTicketsLeft && { onSucceeded: onTicketsLeft })}
      />
    </>
  );
}
